<template>
  <div class="page-main">
    <!-- 翻转时钟容器 -->
    <div class="flip-clock-wrapper">
      <!-- 翻转时钟 -->
      <div class="flip-clock">
        <div class="flip-unit">
          <div class="flip-box" :class="{ flipping: yearFlipping }">
            <span>{{ displayYear }}</span>
          </div>
          <span class="flip-label">年</span>
        </div>

        <span class="time-separator">-</span>

        <div class="flip-unit">
          <div class="flip-box" :class="{ flipping: monthFlipping }">
            <span>{{ displayMonth }}</span>
          </div>
          <span class="flip-label">月</span>
        </div>

        <span class="time-separator">-</span>

        <div class="flip-unit">
          <div class="flip-box" :class="{ flipping: dayFlipping }">
            <span>{{ displayDay }}</span>
          </div>
          <span class="flip-label">日</span>
        </div>

        <span class="time-separator big">|</span>

        <div class="flip-unit">
          <div class="flip-box" :class="{ flipping: hourFlipping }">
            <span>{{ displayHour }}</span>
          </div>
          <span class="flip-label">时</span>
        </div>

        <span class="time-separator">:</span>

        <div class="flip-unit">
          <div class="flip-box" :class="{ flipping: minuteFlipping }">
            <span>{{ displayMinute }}</span>
          </div>
          <span class="flip-label">分</span>
        </div>

        <span class="time-separator">:</span>

        <div class="flip-unit">
          <div class="flip-box" :class="{ flipping: secondFlipping }">
            <span>{{ displaySecond }}</span>
          </div>
          <span class="flip-label">秒</span>
        </div>
      </div>

      <!-- 问候语和欢迎信息 -->
      <div class="info-section">
        <div class="greeting">{{ strHi }}</div>
        <div class="user-info">
          <div>尊敬的</div>
          <div class="user-name">{{ selfAccountData.nick_name }}</div>
        </div>
        <div class="system-info">
          <div>欢迎使用</div>
          <div class="system-name">钢材伙伴-后台管理系统</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    selfAccountData() {
      let result = this.$store.getters.getLoginAccount
      return result
    }
  },
  data() {
    return {
      timer: null,
      strHi: '',
      displayYear: '0000',
      displayMonth: '00',
      displayDay: '00',
      displayHour: '00',
      displayMinute: '00',
      displaySecond: '00',
      yearFlipping: false,
      monthFlipping: false,
      dayFlipping: false,
      hourFlipping: false,
      minuteFlipping: false,
      secondFlipping: false,
      prevYear: '0000',
      prevMonth: '00',
      prevDay: '00',
      prevHour: '00',
      prevMinute: '00',
      prevSecond: '00'
    }
  },
  mounted() {
    this.getCurrentTime()
    this.timer = setInterval(() => {
      this.getCurrentTime()
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    /**
     * 获取当前时间并判断问候语
     */
    getCurrentTime() {
      let now = new Date()
      let hour = now.getHours()

      let result = ''
      if (hour >= 6 && hour < 12) {
        result = `早上好，愿你今天的每一刻都从容而充实...`
      } else if (hour >= 12 && hour < 14) {
        result = `中午好，忙碌间隙记得歇一歇，给自己一点温柔...`
      } else if (hour >= 14 && hour < 18) {
        result = `下午好，累了就喝口水，慢慢来，你做得很好...`
      } else if (hour >= 18 && hour < 24) {
        result = `晚上好，把疲惫留在门外，安心享受属于自己的时光...`
      } else {
        result = `凌晨好，夜已深，愿你的辛劳都能迎来美好的回响...`
      }
      this.strHi = result

      const year = now.getFullYear().toString()
      const month = (now.getMonth() + 1).toString().padStart(2, '0')
      const day = now.getDate().toString().padStart(2, '0')
      const h = now.getHours().toString().padStart(2, '0')
      const m = now.getMinutes().toString().padStart(2, '0')
      const s = now.getSeconds().toString().padStart(2, '0')

      // 检查变化并触发翻转
      this.checkAndFlip('year', year)
      this.checkAndFlip('month', month)
      this.checkAndFlip('day', day)
      this.checkAndFlip('hour', h)
      this.checkAndFlip('minute', m)
      this.checkAndFlip('second', s)

      // 更新显示值
      this.displayYear = year
      this.displayMonth = month
      this.displayDay = day
      this.displayHour = h
      this.displayMinute = m
      this.displaySecond = s
    },

    /**
     * 检查时间值是否变化并触发翻转动画
     * @param {String} type 时间类型
     * @param {String} value 当前值
     */
    checkAndFlip(type, value) {
      const prevValue = this[`prev${type.charAt(0).toUpperCase() + type.slice(1)}`]
      const flipKey = `${type}Flipping`

      if (prevValue !== value) {
        if (!this[flipKey]) {
          this[flipKey] = true
          this[`prev${type.charAt(0).toUpperCase() + type.slice(1)}`] = value

          setTimeout(() => {
            this[flipKey] = false
          }, 600)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
  font-size: 16px;
  line-height: 2;
  padding: 50px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

/* 翻转时钟容器 */
.flip-clock-wrapper {
  background: linear-gradient(135deg, #ffffff 0%, #f5f7fa 50%, #e8ecf0 100%);
  border-radius: 24px;
  box-shadow:
    0 20px 60px rgba(0, 0, 0, 0.1),
    0 1px 3px rgba(0, 0, 0, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  padding: 50px;
  max-width: 100%;
  width: fit-content;
  border: 1px solid rgba(255, 255, 255, 0.5);
}

/* 翻转时钟 */
.flip-clock {
  display: flex;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}

/* 翻转单元 */
.flip-unit {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

/* 翻转盒子 */
.flip-box {
  position: relative;
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  box-shadow:
    0 6px 20px rgba(39, 174, 96, 0.3),
    0 2px 6px rgba(0, 0, 0, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
  background: linear-gradient(180deg, #2ecc71 0%, #27ae60 50%, #1e8449 100%);
  transition: all 0.3s ease;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 50%;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, transparent 100%);
    pointer-events: none;
  }

  span {
    font-size: 42px;
    font-weight: 800;
    color: #ffffff;
    text-shadow:
      0 2px 4px rgba(0, 0, 0, 0.3),
      0 1px 2px rgba(0, 0, 0, 0.2);
    line-height: 1;
    letter-spacing: -1px;
  }

  &.flipping {
    background: linear-gradient(180deg, #e74c3c 0%, #c0392b 50%, #a93226 100%);
    box-shadow:
      0 6px 20px rgba(231, 76, 60, 0.4),
      0 2px 6px rgba(0, 0, 0, 0.2);
    animation: flipAnimation 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
}

/* 翻转动画 - 曲线变化，非匀速 */
@keyframes flipAnimation {
  0% {
    transform: perspective(600px) rotateX(0deg) scale(0);
  }
  25% {
    transform: perspective(600px) rotateX(-45deg) scale(0.1);
  }
  50% {
    transform: perspective(600px) rotateX(-270deg) scale(0.5);
  }
  75% {
    transform: perspective(600px) rotateX(-360deg) scale(1);
  }
  100% {
    transform: perspective(600px) rotateX(-360deg) scale(1);
  }
}

/* 标签 */
.flip-label {
  font-size: 13px;
  color: #666666;
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 4px 10px;
  margin-top: 10px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 8px;
}

/* 时间分隔符 */
.time-separator {
  font-size: 36px;
  color: #999999;
  width: 24px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  flex-shrink: 0;

  &.big {
    font-size: 24px;
    color: #cccccc;
    width: 80px;
  }
}

/* 信息区域 */
.info-section {
  margin-top: 28px;
  padding-top: 25px;
  border-top: 1px dashed rgba(0, 0, 0, 0.08);
  text-align: center;
}

.greeting {
  font-size: 17px;
  color: #555555;
  line-height: 1.6;
  font-weight: 400;
}

.user-info {
  font-size: 15px;
  color: #666666;
  margin-top: 20px;

  .user-name {
    color: #3498db;
    font-weight: 600;
    margin-left: 6px;
  }
}

.system-info {
  font-size: 15px;
  color: #666666;
  margin-top: 20px;

  .system-name {
    color: #27ae60;
    font-weight: 600;
    margin-left: 6px;
  }
}
</style>
